import styled from 'styled-components';
import { theme } from '../globalStyle/global-styles';

export const InputWrapper = styled.div<{ islabelVisible: boolean }>`
  label {
    display: inline-block;
    width: 100%;
    color: ${theme.colours.black};
    p {
      font-family: ${theme.fonts.Medium};
      font-size: 14px;
      margin-bottom: 8px;
      color: ${theme.colours.blackText};
      visibility: ${(props) => (props.islabelVisible ? 'visible' : 'hidden')};
    }
    svg {
      fill: ${theme.colours.Nickel};
    }
    input {
      width: 100%;
      font-family: ${theme.fonts.Medium};
      font-size: 14px;
      color: ${theme.colours.black};
      padding: 12px 35px;
      border-radius: 8px;
      border: 1px solid ${theme.colours.SpanishGray};
      &::placeholder {
        color: ${theme.colours.Nickel};
      }
    }
  }
`;
